/**
 * Refresh if our app version has changed
 */
const getVersionFromHtml = function(html) {
  const meta = html.querySelector('meta[name="X-App-Version"]');
  return meta ? meta.getAttribute('content') : null;
};

const currentVersion = getVersionFromHtml(document);
console.log('app:currentVersion', currentVersion);

// reload if new build version detected
up.on('up:fragment:loaded', (event) => {
  const parser = new DOMParser();
  const parsedHtml = parser.parseFromString(event.response.text, 'text/html');
  const responseVersion = getVersionFromHtml(parsedHtml);

  // Fragment responses (e.g. polling endpoints) may not include the meta tag — skip check
  if (!responseVersion) return;

  up.log.puts('app:responseVersion', responseVersion);
  if (responseVersion !== currentVersion) {
    up.log.warn('app:versionMismatch', 'New version detected: ' + responseVersion + ' !== ' + currentVersion);
    up.cache.expire();
    event.preventDefault();

    // request.loadPage() submits a real <form>, which browsers always
    // suffix with a trailing "?" for GET requests with no fields. Safe
    // (GET) requests have no body to replay, so navigate directly instead;
    // only fall back to the form-submit path for unsafe methods (POST etc).
    if (event.request.isSafe()) {
      window.location.assign(event.request.url);
      return;
    }
    return event.request.loadPage();
  }
});


/**
 * Videos break in Safari when they are injected into the DOM.
 * - Only binds event if Safari browser
 * - `initialLoad` flag avoids our code running on initial page render
 * - Query for all video elements inside fragment
 * - Overwriting its `outerHTML` forces Safari to re-render the video.
 */
const isSafari = () => {
  const ua = navigator.userAgent;
  console.log(`User Agent: ${ua}`);
  return ua.includes('Safari') && !ua.includes('Chrome') && !ua.includes('CriOS') && !ua.includes('FxiOS');
};

if (isSafari()) {
  let initialLoad = true;
  up.on('up:fragment:inserted', (event, fragment) => {
    if (initialLoad) {
      initialLoad = false;
      return;
    }

    const videos = fragment.querySelectorAll('video');
    if (videos.length === 0) return;

    videos.forEach((video) => {
      video.outerHTML = video.outerHTML;
    });
  });
}

/**
 * Make sure logins are always rendered on the main layer.
 */
up.on('up:fragment:loaded', (event) => {
  if (event.response.url.includes('/login')) {
    event.renderOptions.layer = 'root';
    event.renderOptions.target = '[up-id=main]';
  }
});
